import {
    AfterViewInit,
    Component, EventEmitter, Input, Output
} from '@angular/core';
import { AddressModel } from '../../../../shared/models/address.model';
import { DeliveryStepsService } from '../../../services/delivery-steps.service';
import { AuthenticatedUserRepositoryService } from '../../../services/authenticated-user-repository.service';
import { MobileScrollToService } from '../../../../shared/services/mobile-scroll-to.service';

@Component({
    'selector': 'payment-delivery-addresses-list',
    'templateUrl': './payment-delivery-addresses-list.component.html'
})
export class PaymentDeliveryAddressesListComponent implements AfterViewInit {
    public flagNewAddress = false;
    @Input() addresses: Array<AddressModel> = [];
    @Input() creatingAddressZipCode = '';
    @Output() selectedAddress: EventEmitter<AddressModel> = new EventEmitter();

    constructor(
        protected deliverySteps: DeliveryStepsService,
        protected authenticatedUserService: AuthenticatedUserRepositoryService,
        private mobileScrollToService: MobileScrollToService
    ) {
        this.authenticatedUserService.resetedUser$.subscribe(() => {
            this.flagNewAddress = false;
        });
        this.deliverySteps.resetedSelectedAddress$.subscribe(() => {
            this.flagNewAddress = false;
        });
    }

    ngAfterViewInit() {
        this.mobileScrollToService.scrollTo('#scroll-to-delivery-addresses');
        if (this.deliverySteps.inputtedZipCode !== null) {
            this.creatingAddressZipCode = this.deliverySteps.inputtedZipCode;
            this.flagNewAddress = true;
        }
    }

    /**
     * 'flagNewAddress' property setter.
     **/
    public setFlagNewAddress(value: boolean): void {
        this.flagNewAddress = value;
    }
    /**
     * This mark address as selected address.
     **/
    public selectAddress(address: AddressModel): void {
        this.flagNewAddress = false;
        this.onSelectedAddress(address);
    }
    /**
     * This verify if address option must be checked.
     **/
    public isAddressSelected(address: AddressModel): boolean {
        return this.deliverySteps.hasSelectedAddress()
            && this.deliverySteps.getSelectedAddress().id === address.id
            && !this.flagNewAddress;
    }
    /**
     * selected event listener
     **/
    public onSelectedAddress(address: AddressModel) {
        this.selectedAddress.emit(address);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/app/payment/delivery/addresses/list/payment-delivery-addresses-list.component.ts